import React from 'react';
import CredentialTypeForm from './CredentialTypeForm';

const EditCredentialType = ({ credentialType, onSave, onCancel }) => (
  <CredentialTypeForm initial={credentialType} onSave={onSave} onCancel={onCancel} />
);

export default EditCredentialType;
